import { render, staticRenderFns } from "./orderDtl.vue?vue&type=template&id=5531c6cc&scoped=true&"
import script from "./orderDtl.vue?vue&type=script&lang=js&"
export * from "./orderDtl.vue?vue&type=script&lang=js&"
import style0 from "./orderDtl.vue?vue&type=style&index=0&id=5531c6cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5531c6cc",
  null
  
)

export default component.exports